<template>
  <!-- 新用户充值流水控制 -->
  <div>
    <el-dialog
      :visible.sync="showMark"
      :close-on-click-modal="false"
      :title="typeNum === 1 ? '添加控制' : '编辑控制'"
      width="700px"
      @close="closeDialog"
    >
      <div v-loading="loading">
        <p class="text-line">
          <el-switch
            v-model="dataFrom.status"
            :active-value="2"
            :inactive-value="1"
            active-text="打开"
            inactive-text="关闭"
          >
          </el-switch>
        </p>
        <p class="text-line">
          <span>限制名称：</span>
          <el-input
            style="width: 150px"
            v-model="dataFrom.name"
            :disabled="
              dataFrom.id === 4 || dataFrom.id === 5 || dataFrom.id === 8
            "
            placeholder="请输入限制名称"
          ></el-input>
        </p>
        <p
          class="text-line"
          v-for="(item, index) in dataFrom.water_control_limits"
          :key="index"
        >
          &nbsp;当日充值&nbsp;
          <el-input
            style="width: 150px"
            v-model="item.recharge_amount"
            placeholder="请输入限制金额"
          ></el-input>
          &nbsp;及以下控制出不了&nbsp;
          <el-input
            style="width: 150px"
            v-model="item.prize_amount"
            placeholder="请输入限制金额"
          ></el-input>
          &nbsp;及以上的&nbsp;
          <i
            v-if="dataFrom.water_control_limits.length > 1"
            class="el-icon-remove-outline reduce_btn"
            @click="reduceTextLine(index)"
          ></i>
          <i
            v-if="dataFrom.water_control_limits.length - 1 === index"
            class="el-icon-circle-plus-outline add_btn"
            @click="addTextLine"
          ></i>
        </p>
        <p class="btn-box">
          <el-button @click="closeDialog">取消</el-button>
          <el-button type="primary" @click="submit" :loading="buttonLoading"
            >确定</el-button
          >
        </p>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import {
  mapActions,
  mapMutations,
  mapState
} from 'vuex'
import {
  delApiData,
  getApiData,
  postApiData,
  patchApiData
} from '../../http'
export default {
  components: {},
  props: {
    value: {
      type: Object,
      default: undefined
    },
    controlType: {
      type: Number,
      default: 1
    },
    visible: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      loading: false, //弹窗加载动画
      buttonLoading: false, //按钮加载动画
      backListSwitch: 0, //打开或关闭 0是关闭 1是打开
      dataFrom: {
        status: 1, //开关状态 0是关闭 1是打开
        name: undefined, //控制名称
        water_control_limits: [{
          recharge_amount: 0,
          prize_amount: ''
        }], //设置弹窗初始数据
      }
    }
  },
  computed: {
    showMark: { //显示标志
      get() {
        return this.visible
      },
      set() { }
    },
    controlInfo: { //传来的数据
      get() {
        return this.value
      },
      set() { }
    },
    typeNum: { //弹窗类型
      get() {
        return this.controlType
      },
      set() { }
    }
  },
  watch: {
    showMark(val) {
      if (val) {
        if (this.typeNum === 1) {
          //设默认值
          this.dataFrom.status = 1
          this.dataFrom.water_control_limits = [{
            recharge_amount: 0,
            prize_amount: ''
          }]
          this.dataFrom.name = undefined
        } else if (this.typeNum === 2) {
          this.getData() //获取弹窗数据
        }
      }
    }
  },
  created() {

  },
  methods: {
    getData() {
      //获取表单数据
      this.loading = true
      getApiData(`water_control/${this.controlInfo.id}`).then(res => {
        if (res) {
          this.dataFrom = res[0]
          if (this.dataFrom.water_control_limits.length <= 0) {
            this.dataFrom.water_control_limits.push({
              recharge_amount: 0,
              prize_amount: ''
            })
          }
          //设置底部导航条数据
          this.dataMeta = res[0]

          //按金额进行从小到大排序
          for (let i = 0; i < this.dataFrom.water_control_limits.length - 1; i++) {
            for (let j = 0; j < this.dataFrom.water_control_limits.length - 1 - i; j++) {
              if (this.dataFrom.water_control_limits[j].recharge_amount > this.dataFrom.water_control_limits[j + 1]
                .recharge_amount) {
                let temp = this.dataFrom.water_control_limits[j];
                this.dataFrom.water_control_limits[j] = this.dataFrom.water_control_limits[j + 1];
                this.dataFrom.water_control_limits[j + 1] = temp;
              }
            }
          }
        }
      }).finally(() => {
        this.loading = false
      })
    },
    submit() {
      //保存编辑好的表单信息
      this.buttonLoading = true
      let List
      if (this.dataFrom.water_control_limits.length === 1) {
        if ((!this.dataFrom.water_control_limits[0].recharge_amount || this.dataFrom.water_control_limits[0]
          .recharge_amount == 0) && (!this.dataFrom.water_control_limits[0]
            .prize_amount || this.dataFrom.water_control_limits[0].prize_amount == '')) {
          List = []
        } else {
          List = this.dataFrom.water_control_limits
        }
      } else {
        List = this.dataFrom.water_control_limits
      }

      if (List) {
        for (let i = 0; i < List.length; i++) {
          if (List[i] && (List[i].prize_amount <= 0 || !List[i].prize_amount)) {
            this.$message.error("出货金额不能小于等于0")
            this.buttonLoading = false
            return
          }
        }
      }

      let params = JSON.parse(JSON.stringify(this.dataFrom))
      params.water_control_limits = List
      // open_box_limit 接口后跟1是充值流水,2是开箱流水,3是新用户开箱流水
      if (this.typeNum === 1) {
        postApiData('water_control', params)
          .then(res => {
            this.$message.success("保存成功！")
            this.$emit('refresh')
            this.closeDialog() //关闭弹窗
          })
          .finally(() => {
            this.buttonLoading = false
          })
      } else if (this.typeNum === 2) {
        patchApiData(`water_control/${this.controlInfo.id}`, params)
          .then(res => {
            this.$message.success("保存成功！")
            this.$emit('refresh')
            this.closeDialog() //关闭弹窗
          })
          .finally(() => {
            this.buttonLoading = false
          })
      }
    },
    addTextLine() {
      //加行
      let params = {
        recharge_amount: 0,
        prize_amount: ''
      }
      this.dataFrom.water_control_limits.push(params)
    },
    reduceTextLine(num) {
      //减行
      this.dataFrom.water_control_limits.splice(num, 1)
    },
    closeDialog() {
      //关闭弹窗
      this.$emit('close')
    },
  }
}

</script>
<style lang="less" scoped>
</style>
